import store from '@/store'
import router from '@/router'
//import JsEncrypt from 'jsencrypt'
export default {
	getUserInfo(callback) {
		if(store.state.token) {
			axios.post(_PROXY_ + '/seller/info/query.do',{
				token:store.state.token
			}).then(function(res) {
				let data = res.data
				if(data.success){
					store.commit('storeUserInfo',data.result.data)
				}
				typeof callback == 'function' && callback()
			})
		} else {
			router.push({
				name: 'login'
			})
		}
	},
	sendCode(params,callback,$this){
		let that=this;
		axios.post(_PROXY_ + '/common/sendMsg',params)
		.then(function(res) {
			let data = res.data
			typeof callback == 'function' && callback(data)
		}).catch(function(error){
			that.showPopup($this,error.message);
		})
	},
	countdown(time,vue,prop,callback){
		!function run(){
          if(time == 0){
          	typeof callback == 'function' && callback()
            return false
          }else{
          	vue[prop] = time
            time --
          }
          setTimeout(function() {  
            run()
          },1000)
        }()
	},
	// countDownOrder(vue,differ){
	// 	vue.differ = differ
	// 	let timer = setInterval(function() {  
	// 		vue.restTime = vue.common.restTime(vue.differ)
	// 		  if(vue.differ <= 0){
	// 			clearInterval(timer)
	// 			return false
	// 		  }else{
	// 			vue.differ --
	// 		  }
	// 	},1000)
	// 	// !function run(vue){
			
			  
	// 	// }(vue)
	// },
	getOrderStatus(v){
		let l
		_ORDERSTATUS_.some(s => {
			if(v == s.value){
				l = s.label
				return true
			}
		})
		return l
	},
	showPopup(vue,msg,callback){
  		const popup = vue.$refs.promptPopup
  		vue.popupTxt = msg
  		popup.show()
  		setTimeout(() => {
	      popup.hide()
	      typeof callback == 'function' && callback()
	    }, vue.$store.state.popupTime)
  	},
	getRsaPassword(ps){
	    let jse = new JsEncrypt()
	    jse.setPublicKey(store.state.publicKey)
	    let encrypted = jse.encrypt(ps)
	    return encrypted
	  },
	  toast(vue,tex){
		  if(!tex){
			tex="数据加载中....";
		  }	
		const toast = vue.$createToast({
			txt: tex,
			mask: true
		  });
		return toast;
	  },
	formatDate (dt,dy) {
	    if(!dt)return ''
	    let dtArr = dt.split('T')
	    let yArr = dtArr[0].split('-')
	    let hArr = dtArr[1].split(':')
	    let time = new Date(yArr[0],yArr[1] - 1,yArr[2],hArr[0],hArr[1],hArr[2])
	    let year = time.getFullYear()
	    let month = formatNumber(time.getMonth() + 1)
	    let day = formatNumber(time.getDate())
	    let hour = formatNumber(time.getHours())
	    let minute = formatNumber(time.getMinutes())
		let second = formatNumber(time.getSeconds())
	    function formatNumber (num) {
	      if(num < 10){
	        num = '0' + num
	      }
	      return num
	    }
	    if(typeof dy != 'number' && dy){
	      return year + '.' + month + '.' + day
	    }else{
			return year + '.' + month + '.' + day + ' ' + hour + ':' + minute + ':' + second
	    }
  	},
  	restTime(time){
		let str = ''
		let days = Math.floor(time / (24 * 60 *60))
		let hours = Math.floor(time % (24 * 60 *60)  / (60 * 60))
		let minutes = Math.floor(time % (60 * 60) / 60)
		let seconds = Math.floor(time % 60)
		
		if(days > 0){
			str += days + '天'
		}
		if(hours > 0){
			str += hours + '小时'
		}
		if(minutes > 0){
			str += minutes + '分钟'
		}
		if(seconds > 0){
			str += seconds + '秒'
		}
		return str
	},
	isPc() {
		let userAgentInfo = navigator.userAgent;
		let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
		let flag = true;
		for(let v = 0; v < Agents.length; v++) {
			if(userAgentInfo.indexOf(Agents[v]) > 0) {
				flag = false;
				break;
			}
		}
		return flag;
	},
	getBankNo(no){
		if (no) {
			return no.substring(0, 4)+"****"+no.substring(no.length-4);
		}
	},
	randerFloat:function(str){
		if(!str){
			return 0.00;
		}
		return str;
	},
	copyObj:function (obj1,obj2){//对象反射赋值
		for (var key in obj1) {
		  obj1[key] = obj2[key];
		}
		return obj1;
	  },
	  checkluhnBankNo(bankno){
		    var lastNum = bankno.substr(bankno.length - 1, 1); //取出最后一位（与luhn进行比较）
			var first15Num = bankno.substr(0, bankno.length - 1); //前15或18位
			var newArr = new Array();
			for (var i = first15Num.length - 1; i > -1; i--) { //前15或18位倒序存进数组
				newArr.push(first15Num.substr(i, 1));
			}
			var arrJiShu = new Array(); //奇数位*2的积 <9
			var arrJiShu2 = new Array(); //奇数位*2的积 >9
			var arrOuShu = new Array(); //偶数位数组
			for (var j = 0; j < newArr.length; j++) {
				if ((j + 1) % 2 == 1) { //奇数位
					if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);
					else arrJiShu2.push(parseInt(newArr[j]) * 2);
				} else //偶数位
				arrOuShu.push(newArr[j]);
			}

			var jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
			var jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
			for (var h = 0; h < arrJiShu2.length; h++) {
				jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
				jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
			}

			var sumJiShu = 0; //奇数位*2 < 9 的数组之和
			var sumOuShu = 0; //偶数位数组之和
			var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
			var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
			var sumTotal = 0;
			for (var m = 0; m < arrJiShu.length; m++) {
				sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
			}

			for (var n = 0; n < arrOuShu.length; n++) {
				sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
			}

			for (var p = 0; p < jishu_child1.length; p++) {
				sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
				sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
			}
			//计算总和
			sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

			//计算luhn值
			var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
			var luhn = 10 - k;

			if (lastNum == luhn) {
				return true;
			} else {
				return false;
			}
	  },
	  toDecimal2(x) { 
		var f = parseFloat(x); 
		if (isNaN(f)) { 
		return false; 
		} 
		var f = Math.round(x*100)/100; 
		var s = f.toString(); 
		var rs = s.indexOf('.'); 
		if (rs < 0) { 
		rs = s.length; 
		s += '.'; 
		} 
		while (s.length <= rs + 2) { 
		s += '0'; 
		} 
		return s; 
		} 
}